import { SFStack } from "../grid";
import SFCard, { SFCardBody } from ".";
import getStyled from "../../hooks/getStyled";
import PropTypes from "prop-types";
import SFTypography from "../typography";
import { SFInformationIcon } from "../icons";

const { styled } = getStyled();

const SFCardStyled = styled(SFCard)(({ theme }) => ({
  borderRadius: theme.spacing(1),
}));

const SFCardBodyStyled = styled(SFCardBody)(({ theme }) => ({
  backgroundColor: theme.palette.grey50.main,
}));

const SFNoResultsCard = ({ variant, header, description, icon }) => {
  if (variant == "secondary") {
    return (
      <SFCardStyled>
        <SFCardBodyStyled>
          <SFStack direction="row" spacing={1} alignItems="flex-start">
            {icon}
            <SFStack direction="column" spacing={0.5}>
              <SFTypography variant="h4" color="grey500">
                {header}
              </SFTypography>
              <SFTypography variant="body1" color="grey400">
                {description}
              </SFTypography>
            </SFStack>
          </SFStack>
        </SFCardBodyStyled>
      </SFCardStyled>
    );
  }

  return (
    <SFCardBody>
      <SFStack direction="row" spacing={2} alignItems="center">
        {icon ?? <SFInformationIcon size="xxlarge" />}
        <SFStack direction="column" spacing={0.5}>
          <SFTypography variant="h1">{header}</SFTypography>
          <SFTypography variant="body1">{description}</SFTypography>
        </SFStack>
      </SFStack>
    </SFCardBody>
  );
};

SFNoResultsCard.defaultProps = {
  variant: "primary",
};

SFNoResultsCard.propTypes = {
  variant: PropTypes.oneOf(["primary", "secondary"]),
  header: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.element,
};

export default SFNoResultsCard;
